import React from "react";
import { useNavigate } from "react-router-dom";
import { useToast } from "duck";
import { MedicalCasesDocument, useCopyMedicalCaseMutation } from "requests";
import { hooks, SelectionContext } from "../../../../../../../duck";

export const useCopy = () => {
  const { selection, reset } = React.useContext(SelectionContext);
  const toast = useToast();
  const navigate = useNavigate();

  const variables = hooks.useListQueryVariables();
  const [copy, { loading }] = useCopyMedicalCaseMutation({
    awaitRefetchQueries: true,
    refetchQueries: [{ query: MedicalCasesDocument, variables }]
  });

  return {
    loading,
    copy: () => {
      const selectedCase = selection[0];

      return copy({ variables: { input: { _id: selectedCase._id } } }).then(
        ({ data }) => {
          navigate(
            `/cases/${data?.copyMedicalCase?.medicalCase?._id}/check-in`
          );
          toast({
            status: "success",
            description: `Case ${data?.copyMedicalCase?.medicalCase?.name} is created successfully.`
          });
          reset();
        }
      );
    }
  };
};
